import {
    ADD_PERSONA_AUDIENCE,
    ADD_CONTENT_TYPE_LIST,
    ADD_VEEVA_SPECILTY_LIST,
    ADD_PERSONA_AUDIENCE_LIST,
    ADD_PERSONA_GROUP,
    ADD_PERSONA_GROUP_LIST,
    ADD_COUNTRY,
} from "./actionTypes";

interface ISetPersonaAudience {
    type: string;
    payload: any;
}

const initialState = {
    persona: {
        personaAudience: {
            personaName: "",
            appName: "",
            country: "",
            audienceSpecialty: [],
        },
        contentType: [],
        veevaSpecialties: {},
        personaAudienceList: [],
        personaGroup: {
            personaName: "",
            appName: "",
            country: "",
            email: [],
        },
        personaGroupList: [],
        country: "",
    },
};

export default (state = initialState, action: ISetPersonaAudience) => {
    switch (action.type) {
        case ADD_PERSONA_AUDIENCE: {
            if (!action.payload) {
                return {
                    ...initialState.persona.personaAudience,
                };
            }
            return {
                ...state,
                persona: {
                    veevaSpecialties: state.persona.veevaSpecialties,
                    contentType: state.persona.contentType,
                    personaAudience: { ...action.payload },
                },
            };
        }
        case ADD_CONTENT_TYPE_LIST: {
            if (!action.payload) {
                return {
                    ...initialState.persona.contentType,
                };
            }
            return {
                ...state,
                persona: {
                    ...state.persona,
                    veevaSpecialties: state.persona.veevaSpecialties,
                    contentType: action.payload,
                },
            };
        }
        case ADD_VEEVA_SPECILTY_LIST: {
            if (!action.payload) {
                return {
                    ...initialState.persona.veevaSpecialties,
                };
            }
            return {
                ...state,
                persona: {
                    ...state.persona,
                    contentType: state.persona.contentType,
                    veevaSpecialties: action.payload,
                },
            };
        }
        case ADD_PERSONA_AUDIENCE_LIST: {
            if (!action.payload) {
                return {
                    ...initialState.persona.personaAudienceList,
                };
            }
            return {
                ...state,
                persona: {
                    ...state.persona,
                    personaAudienceList: action.payload,
                },
            };
        }
        case ADD_PERSONA_GROUP: {
            if (!action.payload) {
                return {
                    ...initialState.persona.personaGroup,
                };
            }
            return {
                ...state,
                persona: {
                    ...state.persona,
                    personaGroup: action.payload,
                },
            };
        }
        case ADD_PERSONA_GROUP_LIST: {
            if (!action.payload) {
                return {
                    ...initialState.persona.personaGroupList,
                };
            }
            return {
                ...state,
                persona: {
                    ...state.persona,
                    personaGroupList: action.payload,
                },
            };
        }
        case ADD_COUNTRY: {
            if (!action.payload) {
                return {
                    country: initialState.persona.country,
                };
            }
            return {
                ...state,
                persona: {
                    ...state.persona,
                    country: action.payload,
                },
            };
        }
        default:
            return state;
    }
};
